import { createI18n } from 'vue-i18n';

// 默认语言资源
const messages = {
  en: {
    // 这里可以添加英文翻译
  },
  zh: {
    // 这里可以添加中文翻译
  }
};

const i18n = createI18n({
  legacy: false,
  locale: 'zh',
  fallbackLocale: 'en',
  messages
});

export default i18n;